import extend from 'extend';
import Q from 'q';
import _ from 'underscore';

import BaseMultipleEntitySelector from "../../base-multiple-entity-selector-0300/1.0.0/index.js";

export default {
    mixins: [
        BaseMultipleEntitySelector,
    ],

    data() {
        return {

            dialog: {
                show: false,
            },

            init_parameter: {

                situation: `100`,

                dialog: {
                    title: `请选择`,
                    width: `1100px`,
                },

            },

        };
    },

    methods: {

        //<editor-fold desc="dialog">

        __dialog_open_event_handler() {
            const __this = this;
            __this.left_input.value = ``;
            __this.right_input.value = ``;
            __this.__init_data_source();
        },

        __dialog_opened_event_handler() {
            const __this = this;
        },

        //</editor-fold>

        __btn_cancel_click() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;

            __this.dialog.show = false;

            const value_for_v_model = __this.value_for_v_model;
            const temp_value_for_v_model = __this.temp_value_for_v_model;

            if (temp_value_for_v_model.length > 0) {
                temp_value_for_v_model.splice(0, temp_value_for_v_model.length);
            }
            _.each(value_for_v_model, function (m) {
                temp_value_for_v_model.push(m);
            });

            const btn_cancel_click_event_handler = __this.init_parameter.btn_cancel_click_event_handler;
            if (_.isFunction(btn_cancel_click_event_handler)) {
                btn_cancel_click_event_handler();
            }
        },

        __btn_ok_click() {
            const __this = this;
            const get_selected_entity_list = __this.get_selected_entity_list;

            const temp_value_for_v_model = __this.temp_value_for_v_model;
            const value_for_v_model = __this.value_for_v_model;

            if (value_for_v_model.length > 0) {
                value_for_v_model.splice(0, value_for_v_model.length);
            }
            _.each(temp_value_for_v_model, function (m) {
                value_for_v_model.push(m);
            });

            __this.dialog.show = false;

            const btn_ok_click_event_handler = __this.init_parameter.btn_ok_click_event_handler;
            if (_.isFunction(btn_ok_click_event_handler)) {
                const selected_id_list = __this.value_for_v_model;
                const selected_entity_list = get_selected_entity_list({
                    id_list: selected_id_list,
                });

                btn_ok_click_event_handler({
                    selected_id_list,
                    selected_entity_list,
                });
            }
        },

        //--------------------------------------------------------------------------------------------------------------

        show() {
            const __this = this;
            __this.dialog.show = true
        },

        hide() {
            const __this = this;
            __this.dialog.show = false;
        },

        init(pInitParameter) {
            const __this = this;

            if (!pInitParameter) pInitParameter = {};

            const default_init_parameter = {};

            if (pInitParameter.select_mode) {
                __this.init_parameter.select_mode = pInitParameter.select_mode;
            }
            extend(__this.init_parameter.entity_define, default_init_parameter.entity_define, pInitParameter.entity_define);
            extend(__this.init_parameter.dialog, default_init_parameter.dialog, pInitParameter.dialog);
            extend(__this.init_parameter.table, default_init_parameter.table, pInitParameter.table);
            if (_.isFunction(pInitParameter.get_params)) {
                __this.init_parameter.get_params = pInitParameter.get_params;
            }
            if (_.isFunction(pInitParameter.get_data_source)) {
                __this.init_parameter.get_data_source = pInitParameter.get_data_source;
            }
        },

    },
};
